<!-- Confirmation.svelte -->
<script>
  export let message;
  export let confirmAction;
  export let cancelAction;
</script>

<div class="confirmation-modal">
  <div class="modal-content">
    <p>{message}</p>
    <div class="buttons">
      <button class="no" on:click={cancelAction}>No</button>
      <button class="yes" on:click={confirmAction}>Yes</button>
    </div>
  </div>
</div>

<style>
  .confirmation-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 80%;
    width: 500px;
    text-align: center;
  }

  .buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }

  button {
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    border-radius: 5px;
  }

  .yes {
    text-align: center;
    background-color: #dddddd;
    transition: background-color 0.3s ease;
    color: black;
  }

  .yes:hover {
    background-color: #ff3c82;
  }

  .no {
    text-align: center;
    background-color: #1e92ff;
    transition: background-color 0.3s ease;
    color: black;
  }

  .no:hover {
    background-color: #004b91;
  }
</style>
